import { select, call, takeLatest, put } from 'redux-saga/effects';
import { Toaster, Intent, Position } from '@blueprintjs/core';

import * as $ui from 'modules/ui';
import { UI } from 'modules/ui';
import * as $auth from 'modules/auth';
import * as api from '../api';
import * as actions from '../actions';

const InfluencersToaster = Toaster.create({
  position: Position.BOTTOM_RIGHT,
});

const createInfluencer = function* ({ payload }) {
  const token = yield select($auth.getToken);
  const publisherId = yield select($auth.getSelectedPublisherId);

  const { key, ...influencerData } = payload;

  try {
    yield put($ui.setTrue(UI.Influencers.IsCreating)());

    yield call(api.createInfluencer, token, key, publisherId, influencerData);

    yield put($ui.setFalse(UI.Influencers.CreateDialogVisible)());

    yield* refetchInfluencers();
  } catch (error) {
    InfluencersToaster.show({
      icon: 'warning-sign',
      intent: Intent.DANGER,
      message: 'Something went wrong while creating an influencer',
    });
  } finally {
    yield put($ui.setFalse(UI.Influencers.IsCreating)());
  }

  function* refetchInfluencers() {
    const queryParams = new URLSearchParams(window.location.search);
    const pageSize = queryParams.get('pageSize') || 20;
    const pageNumber = 1;

    yield put(actions.fetchInfluencers(pageSize, pageNumber));
  }
};

export const createInfluencerSaga = function* () {
  yield takeLatest(actions.createInfluencer, createInfluencer);
};
